<i18n>
{
	"en": {
		"customersFound": "{count} found",
		"customer": "Customer",
		"allCustomers": "All customers"
	},
	"no": {
		"customersFound": "{count} treff",
		"customer": "Kunde",
		"allCustomers": "Alle kunder"
	}
}
</i18n>

<template>
	<t-multiselect
		ref="input"
		:label="$t('customer')"
		:allItems="customers"
		:selectedItems="selectedItems"
		:placeholder="$t('allCustomers')"
		:itemKeys="['name', 'customerNo']"
		closeOnSelect
		v-bind="$attrs"
		v-on="$listeners"
		@updateFilters="getCustomers"
	/>
</template>

<script>
import { mapActions, mapState } from './store/customers.store.js';
import TMultiselect from '@/components/evergreen/timpex/inputs/TMultiselect';

export default {
	name: 'CustomerSearchInput',
	components: { TMultiselect },
	props: {
		selectedItems: Array,
	},
	computed: {
		...mapState(['customers']),
	},

	methods: {
		...mapActions(['getCustomers']),
		clearInput() {
			this.$refs.input.clearInput();
		},
	},
};
</script>
